/* STACIA: present 5 colour choices first, preserve every supplier-linked variant. */
(() => {
  function prepareColourOptions(root = document) {
    root.querySelectorAll('variant-selects fieldset.stacia-colour-picker').forEach((fieldset) => {
      if (fieldset.dataset.staciaColoursReady === 'true') return;
      const button = fieldset.querySelector('[data-stacia-colour-more]');
      if (!button) return;
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      if (inputs.length <= 5) return;
      const labels = Array.from(fieldset.querySelectorAll('label[for]'));
      const entries = inputs.map((input) => ({
        input,
        label: labels.find((label) => label.htmlFor === input.id)
      }));
      if (entries.some((entry) => !entry.label)) return;
      fieldset.dataset.staciaColoursReady = 'true';
      let expanded = entries.slice(5).some((entry) => entry.input.checked);
      function update() {
        entries.forEach((entry, index) => {
          const hidden = !expanded && index >= 5;
          entry.input.classList.toggle('stacia-colour-hidden', hidden);
          entry.label.classList.toggle('stacia-colour-hidden', hidden);
        });
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'Show fewer colours' : 'View all ' + entries.length + ' colours';
      }
      button.addEventListener('click', () => { expanded = !expanded; update(); });
      fieldset.addEventListener('change', () => {
        if (!expanded && entries.slice(5).some((entry) => entry.input.checked)) {
          expanded = true;
          update();
        }
      });
      update();
    });
  }
  function start() {
    prepareColourOptions();
    const main = document.getElementById('MainContent');
    if (!main || !('MutationObserver' in window)) return;
    const observer = new MutationObserver((mutations) => {
      const newOptions = mutations.some(({addedNodes}) => Array.from(addedNodes).some((node) =>
        node.nodeType === 1 && (
          node.matches?.('variant-selects, fieldset.stacia-colour-picker') ||
          node.querySelector?.('fieldset.stacia-colour-picker')
        )
      ));
      if (newOptions) prepareColourOptions(main);
    });
    observer.observe(main, {subtree:true,childList:true});
    document.addEventListener('shopify:section:load', () => prepareColourOptions(main));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();